export const PH_POSTAL_CODES = {
  // ================= NCR =================
  "City of Caloocan": "1400",
  "City of Las Piñas": "1740",
  "City of Makati": "1200",
  "City of Malabon": "1470",
  "City of Mandaluyong": "1550",
  "City of Manila": "1000",
  "City of Marikina": "1800",
  "City of Muntinlupa": "1770",
  "City of Navotas": "1485",
  "City of Parañaque": "1700",
  "City of Pasig": "1600",
  "City of San Juan": "1500",
  "City of Taguig": "1630",
  "City of Valenzuela": "1440",
  "Pasay City": "1300",
  "Quezon City": "1100",
  "Pateros": "1620",
  "Binondo": "1006", 
  "Ermita": "1000", 
  "Intramuros": "1002", 
  "Malate": "1004",
  "Paco": "1007", 
  "Pandacan": "1011", 
  "Port Area": "1018", 
  "Quiapo": "1001",
  "Sampaloc": "1008", 
  "San Miguel|Manila": "1005", 
  "San Nicolas|Manila": "1010",
  "Santa Ana|Manila": "1009", 
  "Santa Cruz|Manila": "1003", 
  "Tondo I/II": "1012",

  // ================= CAR =================
  // ================= ABRA =================
  "Bangued": "2800",
  "Boliney": "2815",
  "Bucay": "2805",
  "Bucloc": "2817",
  "Daguioman": "2816",
  "Danglas": "2825",
  "Dolores|Abra": "2827",
  "La Paz|Abra": "2826",
  "Lacub": "2821",
  "Lagangilang": "2802",
  "Lagayan": "2824",
  "Langiden": "2807",
  "Licuan-Baay": "2819",
  "Luba": "2813",
  "Malibcong": "2820",
  "Manabo": "2810",
  "Peñarrubia": "2804",
  "Pidigan": "2806",
  "Pilar|Abra": "2812",
  "Sallapadan": "2818",
  "San Isidro|Abra": "2809", 
  "San Juan|Abra": "2823",   
  "San Quintin|Abra": "2808",
  "Tayum": "2803",
  "Tineg": "2822",
  "Tubo": "2814",
  "Villaviciosa": "2811",

  // ================= APAYAO =================
  "Calanasan": "3814",
  "Conner": "3807",
  "Flora": "3810",
  "Kabugao": "3809",
  "Luna|Apayao": "3813",
  "Pudtol": "3812",
  "Santa Marcela": "3811",

  // ================= BENGUET =================
  "Atok": "2612",
  "City of Baguio": "2600",
  "Bakun": "2610",
  "Bokod": "2605",
  "Buguias": "2607",
  "Itogon": "2604",
  "Kabayan": "2606",
  "Kapangan": "2608",
  "Kibungan": "2611",
  "La Trinidad": "2601",
  "Mankayan": "2603",
  "Sablan": "2614",
  "Tuba": "2602",
  "Tublay": "2615",

  // ================= IFUGAO =================
  "Aguinaldo": "3606",
  "Alfonso Lista": "3608",
  "Asipulo": "3610",
  "Banaue": "3601",
  "Hingyon": "3607",
  "Hungduan": "3603",
  "Kiangan": "3604",
  "Lagawe": "3600",
  "Lamut": "3605",
  "Mayoyao": "3602",
  "Tinoc": "3609",

  // ================= KALINGA =================
  "Balbalan": "3801",
  "Lubuagan": "3802",
  "Pasil": "3803",
  "Pinukpuk": "3806",
  "Rizal|Kalinga": "3808",
  "City of Tabuk": "3800",
  "Tanudan": "3805",
  "Tinglayan": "3804",

  // ================= MOUNTAIN PROVINCE =================
  "Barlig": "2623",
  "Bauko": "2621",
  "Besao": "2618",
  "Bontoc|Mountain Province": "2616",
  "Natonin": "2624",
  "Paracelis": "2625",
  "Sabangan|Mountain Province": "2622",
  "Sadanga": "2617",
  "Sagada": "2619",
  "Tadian": "2620",

  // ================= REGION I =================
  // ================= ILOCOS NORTE =================
  "Adams": "2922",
  "Bacarra": "2916",
  "Badoc": "2904",
  "Bangui": "2920",
  "Banna": "2908",
  "City of Batac": "2906",
  "Burgos|Ilocos Norte": "2918",
  "Carasi": "2911",
  "Currimao": "2903",
  "Dingras": "2913",
  "Dumalneg": "2921",
  "City of Laoag": "2900",
  "Marcos": "2907",
  "Nueva Era": "2909",
  "Pagudpud": "2919",
  "Paoay": "2902",
  "Pasuquin": "2917",
  "Piddig": "2912",
  "Pinili": "2905",
  "San Nicolas|Ilocos Norte": "2901",
  "Sarrat": "2914",
  "Solsona": "2915",
  "Vintar": "2911",

  // ================= ILOCOS SUR =================
  "Alilem": "2716",
  "Banayoyo": "2708",
  "Bantay": "2727",
  "Bauguen": "2723", 
  "Burgos|Ilocos Sur": "2724",
  "Cabugao": "2732",
  "City of Candon": "2710",
  "Caoayan": "2702",
  "Cervantes": "2718",
  "Galimuyod": "2709",
  "Gregorio del Pilar": "2720",
  "Lidlidda": "2722",
  "Magsingal": "2730",
  "Narvacan": "2704",
  "Quirino|Ilocos Sur": "2721",
  "San Emilio": "2722",
  "San Esteban": "2706",
  "San Ildefonso|Ilocos Sur": "2728",
  "San Juan|Ilocos Sur": "2731",
  "San Vicente|Ilocos Sur": "2726",
  "Santa": "2703",
  "Santa Catalina": "2701",
  "Santa Cruz|Ilocos Sur": "2713",
  "Santa Lucia": "2712",
  "Santa Maria|Ilocos Sur": "2705",
  "Santiago|Ilocos Sur": "2707",
  "Santo Domingo|Ilocos Sur": "2729",
  "Sigay": "2719",
  "Sinait": "2733",
  "Sugpon": "2717",
  "Suyo": "2715",
  "Tagudin": "2714",
  "City of Vigan": "2700",

  // ================= LA UNION =================
  "Agoo": "2504",
  "Aringay": "2503",
  "Bacnotan": "2515",
  "Bagulin": "2512",
  "Balaoan": "2517",
  "Bangar": "2519",
  "Bauang": "2501",
  "Burgos|La Union": "2510",
  "Caba": "2502",
  "Luna|La Union": "2518",
  "Naguilian|La Union": "2511",
  "Pugo": "2508",
  "Rosario|La Union": "2506",
  "City of San Fernando|La Union": "2500",
  "San Gabriel": "2513",
  "San Juan|La Union": "2514",
  "Santo Tomas|La Union": "2505",
  "Santol": "2516",
  "Sudipen": "2520",
  "Tubao": "2509",

  // ================= PANGASINAN =================
  "Agno": "2408",
  "Aguilar": "2415",
  "City of Alaminos": "2404",
  "Alcala|Pangasinan": "2425",
  "Anda|Pangasinan": "2405",
  "Asingan": "2439",
  "Balungao": "2442",
  "Bani": "2407",
  "Basista": "2422",
  "Bautista": "2424",
  "Bayambang": "2423",
  "Binalonan": "2433",
  "Binmaley": "2417",
  "Bolinao": "2406",
  "Bugallon": "2416",
  "Burgos|Pangasinan": "2410",
  "Calasiao": "2418",
  "City of Dagupan": "2400",
  "Dasol": "2411",
  "Infanta|Pangasinan": "2412",
  "Labrador": "2402",
  "Laoac": "2438",
  "Lingayen": "2401",
  "Mabini|Pangasinan": "2409",
  "Malasiqui": "2421",
  "Manaoag": "2430",
  "Mangaldan": "2432",
  "Mangatarem": "2413",
  "Mapandan": "2429",
  "Natividad": "2446",
  "Pozorrubio": "2435",
  "Rosales": "2441",
  "San Carlos City|Pangasinan": "2420", 
  "San Fabian": "2433",
  "San Jacinto|Pangasinan": "2431",
  "San Manuel": "2438",
  "San Nicolas|Pangasinan": "2447",
  "San Quintin|Pangasinan": "2444",
  "Santa Barbara|Pangasinan": "2419",
  "Santa Maria|Pangasinan": "2440",
  "Santo Tomas|Pangasinan": "2426",
  "Sison|Pangasinan": "2434",
  "Sual": "2403",
  "Tayug": "2445",
  "Umingan": "2443",
  "City of Urbiztondo": "2414",
  "City of Urdaneta": "2428",
  "Villasis": "2427",

  // ================= REGION II =================
  // ================= BATANES =================
  "Basco": "3900",
  "Itbayat": "3905",
  "Ivana": "3902",
  "Mahatao": "3901",
  "Sabtang": "3904",
  "Uyugan": "3903",

  // ================= CAGAYAN =================
  "Abulug": "3517",
  "Alcala|Cagayan": "3507",
  "Allacapan": "3523",
  "Amulung": "3505",
  "Aparri": "3515",
  "Baggao": "3506",
  "Ballesteros": "3516",
  "Buguey": "3511",
  "Calayan": "3520",
  "Camalaniugan": "3510",
  "Claveria|Cagayan": "3533",
  "Enrile": "3501",
  "Gattaran": "3508",
  "Gonzaga": "3513",
  "Iguig": "3504",
  "Lal-lo": "3509",
  "Lasam": "3524",
  "Pamplona|Cagayan": "3522",
  "Peñablanca": "3502",
  "Piat": "3527",
  "Rizal|Cagayan": "3526",
  "Sanchez-Mira": "3532",
  "Santa Ana|Cagayan": "3514",
  "Santa Praxedes": "3534",
  "Santa Teresita|Cagayan": "3512",
  "Santo Niño|Cagayan": "3525",
  "Solana": "3503",
  "Tuao": "3528",
  "City of Tuguegarao": "3500",

  // ================= ISABELA =================
  "Alicia|Isabela": "3306",
  "Angadanan": "3307",
  "Aurora|Isabela": "3316",
  "Benito Soliven": "3331",
  "Burgos|Isabela": "3322",
  "Cabagan": "3303",
  "Cabatuan|Isabela": "3315",
  "City of Cauayan": "3305",
  "Cordon": "3312",
  "Delfin Albano": "3326",
  "Dinapigue": "3336",
  "Divilacan": "3335",
  "Echague": "3309",
  "Gamu": "3301",
  "City of Ilagan": "3300",
  "Jones": "3313",
  "Luna|Isabela": "3304",
  "Maconacon": "3333",
  "Mallig": "3323",
  "Naguilian|Isabela": "3302",
  "Palanan": "3334",
  "Quezon|Isabela": "3324",
  "Quirino|Isabela": "3321",
  "Ramon": "3319",
  "Reina Mercedes": "3303",
  "Roxas|Isabela": "3320",
  "San Agustin|Isabela": "3314",
  "San Guillermo": "3308",
  "San Isidro|Isabela": "3311",
  "San Mariano": "3332",
  "San Mateo|Isabela": "3318",
  "San Pablo|Isabela": "3329",
  "Santa Maria|Isabela": "3330",
  "Santiago City": "3311", 
  "Santo Tomas|Isabela": "3327",
  "Tumauini": "3325",

  // ================= NUEVA VIZCAYA =================
  "Alfonso Castañeda": "3714",
  "Ambaguio": "3701",
  "Aritao": "3704",
  "Bagabag": "3711",
  "Bambang": "3702",
  "Bayombong": "3700",
  "Diadi": "3712",
  "Dupax del Norte": "3706",
  "Dupax del Sur": "3707",
  "Kasibu": "3703",
  "Kayapa": "3708",
  "Quezon|Nueva Vizcaya": "3713",
  "Solano": "3709",
  "Santa Fe|Nueva Vizcaya": "3705",
  "Villaverde": "3710",

  // ================= QUIRINO =================
  "Aglipay": "3403",
  "Cabarroguis": "3400",
  "Diffun": "3401",
  "Maddela": "3404",
  "Nagtipunan": "3405",
  "Saguday": "3402",

  // ================= REGION III =================
  // ================= BATAAN =================
  "Abucay": "2114",
  "Bagac": "2107",
  "City of Balanga": "2100",
  "Dinalupihan": "2110",
  "Hermosa": "2111",
  "Lamao": "2104",
  "Limay": "2103",
  "Mariveles": "2105",
  "Morong|Bataan": "2108",
  "Orani": "2112",
  "Orion": "2102",
  "Pilar|Bataan": "2101",
  "Samal|Bataan": "2113",

  // ================= BULACAN =================
  "Angat": "3012",
  "Balagtas": "3016",
  "Baliuag": "3006",
  "Bocaue": "3018",
  "Bulacan": "3017",
  "Bustos": "3007",
  "Calumpit": "3003",
  "Doña Remedios Trinidad": "3009",
  "Guiguinto": "3015",
  "Hagonoy|Bulacan": "3002",
  "City of Malolos": "3000",
  "Marilao": "3019",
  "City of Meycauayan": "3020",
  "Norzagaray": "3013",
  "Obando": "3021",
  "Pandi": "3014",
  "Paombong": "3001",
  "Plaridel|Bulacan": "3004",
  "Pulilan": "3005",
  "San Ildefonso|Bulacan": "3010",
  "City of San Jose del Monte": "3023",
  "San Miguel|Bulacan": "3011",
  "San Rafael|Bulacan": "3008",
  "Santa Maria|Bulacan": "3022",

  // ================= PAMPANGA =================
  "City of Angeles": "2009",
  "Apalit": "2016",
  "Arayat": "2012",
  "Bacolor": "2001",
  "Candaba": "2013",
  "Floridablanca": "2006",
  "Guagua": "2003",
  "Lubao": "2005",
  "City of Mabalacat": "2010",
  "Macabebe": "2018",
  "Magalang": "2011",
  "Masantol": "2017",
  "Mexico": "2011",
  "Minalin": "2019",
  "Porac": "2008",
  "City of San Fernando|Pampanga": "2000",
  "San Luis|Pampanga": "2014",
  "San Simon": "2015",
  "Santa Ana|Pampanga": "2022",
  "Santa Rita|Pampanga": "2002",
  "Santo Tomas|Pampanga": "2020",
  "Sasmuan": "2004",

  // ================= ZAMBALES =================
  "Botolan": "2202",
  "Cabangan|Zambales": "2203",
  "Candelaria|Zambales": "2212",
  "Castillejos": "2208",
  "Iba": "2201",
  "Masinloc": "2211",
  "City of Olongapo": "2200",
  "Palauig": "2210",
  "San Antonio|Zambales": "2206",
  "San Felipe": "2204",
  "San Marcelino": "2207",
  "San Narciso|Zambales": "2205",
  "Santa Cruz|Zambales": "2213",
  "Subic": "2209",

  // ================= AURORA =================
  "Baler": "3200",
  "Casiguran|Aurora": "3204",
  "Dilasag": "3205",
  "Dinalungan": "3206",
  "Dingalan": "3207",
  "Dipaculao": "3203",
  "Maria Aurora": "3202",
  "San Luis|Aurora": "3201",

  // ================= REGION IV-A =================
  // ================= BATANGAS =================
  "Agoncillo": "4211",
  "Alitagtag": "4205",
  "Balayan": "4213",
  "Balete|Batangas": "4233",
  "City of Batangas": "4200",
  "Bauan": "4201",
  "Calaca": "4212",
  "Calatagan": "4215",
  "Cuenca": "4210",
  "Ibaan": "4209",
  "Laurel": "4221",
  "Lemery|Batangas": "4212",
  "Lian": "4216",
  "City of Lipa": "4217",
  "Lobo": "4229",
  "Mabini|Batangas": "4202",
  "Malvar": "4233",
  "Mataasnakahoy": "4232",
  "Nasugbu": "4231",
  "Padre Garcia": "4224",
  "Rosario|Batangas": "4225",
  "San Jose|Batangas": "4227",
  "San Juan|Batangas": "4226",
  "San Luis|Batangas": "4210",
  "San Nicolas|Batangas": "4209",
  "San Pascual|Batangas": "4204",
  "Santa Teresita|Batangas": "4206",
  "City of Santo Tomas": "4234",
  "Taal": "4208",
  "Talisay|Batangas": "4220",
  "City of Tanauan": "4232",
  "Taysan": "4228",
  "Tingloy": "4203",
  "Tuy": "4214",

  // ================= CAVITE =================
  "Alfonso": "4123",
  "Amadeo": "4119",
  "City of Bacoor": "4102",
  "Carmona": "4116",
  "City of Cavite": "4100",
  "City of Dasmariñas": "4114",
  "City of General Trias": "4107",
  "General Emilio Aguinaldo": "4124",
  "General Mariano Alvarez": "4117",
  "City of Imus": "4103",
  "Indang": "4122",
  "Kawit": "4104",
  "Magallanes|Cavite": "4113",
  "Maragondon": "4112",
  "Mendez": "4121",
  "Naic": "4110",
  "Noveleta": "4105",
  "Rosario|Cavite": "4106",
  "Silang": "4118",
  "City of Tagaytay": "4120",
  "Tanza": "4108",
  "Ternate": "4111",
  "City of Trece Martires": "4109",

  // ================= LAGUNA =================
  "Alaminos|Laguna": "4001",
  "Bay": "4033",
  "City of Biñan": "4024",
  "City of Cabuyao": "4025",
  "City of Calamba": "4027",
  "Calauan": "4012",
  "Cavinti": "4013",
  "Famy": "4007",
  "Kalayaan|Laguna": "4015",
  "Liliw": "4004",
  "Los Baños": "4030",
  "Luisiana": "4032",
  "Lumban": "4014",
  "Mabitac": "4020",
  "Magdalena": "4007",
  "Majayjay": "4005",
  "Nagcarlan": "4002",
  "Paete": "4016",
  "Pagsanjan": "4008",
  "Pakil": "4017",
  "Pangil": "4018",
  "Pila": "4010",
  "Rizal|Laguna": "4003",
  "City of San Pablo": "4000",
  "City of San Pedro": "4023",
  "City of Santa Rosa": "4026",
  "Santa Cruz|Laguna": "4009",
  "Santa Maria|Laguna": "4022",
  "Siniloan": "4019",
  "Victoria|Laguna": "4011",

  // ================= QUEZON =================
  "Agdangan": "4304",
  "Alabat": "4333",
  "Atimonan": "4331",
  "Buenavista|Quezon": "4320",
  "Burdeos": "4341",
  "Calauag": "4318",
  "Candelaria|Quezon": "4323",
  "Cateel|Quezon": "4311",
  "Guinayangan": "4319",
  "Gumaca": "4307",
  "Infanta|Quezon": "4336",
  "Jomalig": "4342",
  "Lopez": "4316",
  "City of Lucena": "4301",
  "Lucban": "4328",
  "Macalelon": "4309",
  "Mauban": "4330",
  "Mulanay": "4312",
  "Padre Burgos|Quezon": "4302",
  "Pagbilao": "4302",
  "Panukulan": "4337",
  "Patnanungan": "4341",
  "Perez": "4334",
  "Pitogo|Quezon": "4308",
  "Plaridel|Quezon": "4306",
  "Polillo": "4339",
  "Quezon|Quezon": "4332",
  "Real": "4335",
  "Sampaloc|Quezon": "4329",
  "San Andreas": "4314",
  "San Antonio|Quezon": "4324",
  "San Francisco|Quezon": "4315",
  "San Narciso|Quezon": "4313",
  "Sariaya": "4322",
  "Tagkawayan": "4319",
  "City of Tayabas": "4327",
  "Tiaong": "4325",
  "Unisan": "4305",

  // ================= RIZAL =================
  "Angono": "1930",
  "City of Antipolo": "1870",
  "Baras|Rizal": "1970",
  "Binangonan": "1940",
  "Cainta": "1900",
  "Cardona": "1950",
  "Jala-jala": "1990",
  "Morong|Rizal": "1960",
  "Pililla": "1910",
  "Rodriguez": "1860", 
  "San Mateo|Rizal": "1850",
  "Tanay": "1980",
  "Taytay|Rizal": "1920",
  "Teresa": "1880",

  // ================= MIMAROPA =================
  // ================= MARINDUQUE =================
  "Boac": "4900",
  "Buenavista|Marinduque": "4901",
  "Gasan": "4905",
  "Mogpog": "4902",
  "Santa Cruz|Marinduque": "4903",
  "Torrijos": "4904",

  // ================= OCCIDENTAL MINDORO =================
  "Abra de Ilog": "5108",
  "Calintaan": "5102",
  "Looc|Occidental Mindoro": "5111",
  "Lubang": "5109",
  "Magsaysay|Occidental Mindoro": "5101",
  "Mamburao": "5106",
  "Paluan": "5107",
  "Rizal|Occidental Mindoro": "5103",
  "Sablayan": "5104",
  "San Jose|Occidental Mindoro": "5100",
  "Santa Cruz|Occidental Mindoro": "5105",

  // ================= ORIENTAL MINDORO =================
  "Baco": "5201",
  "Bansud": "5210",
  "Bongabong": "5211",
  "Bulalacao": "5214",
  "City of Calapan": "5200",
  "Gloria": "5209",
  "Mansalay": "5213",
  "Naujan": "5204",
  "Pinamalayan": "5208",
  "Pola": "5206",
  "Puerto Galera": "5203",
  "Roxas|Oriental Mindoro": "5212",
  "San Teodoro": "5202",
  "Socorro|Oriental Mindoro": "5207",
  "Victoria|Oriental Mindoro": "5205",

  // ================= PALAWAN =================
  "Aborlan": "5302",
  "Agutaya": "5320",
  "Araceli": "5311",
  "Balabac": "5307",
  "Bataraza": "5306",
  "Brooke's Point": "5305",
  "Busuanga": "5317",
  "Cagayancillo": "5312",
  "Coron": "5316",
  "Culion": "5315",
  "Cuyo": "5318",
  "Dumaran": "5310",
  "El Nido": "5313",
  "Kalayaan|Palawan": "5322",
  "Linapacan": "5314",
  "Magsaysay|Palawan": "5319",
  "Narra": "5303",
  "City of Puerto Princesa": "5300",
  "Quezon|Palawan": "5308",
  "Rizal|Palawan": "5304",
  "Roxas|Palawan": "5309",
  "San Vicente|Palawan": "5315",
  "Sofronio Española": "5305",
  "Taytay|Palawan": "5312",

  // ================= ROMBLON =================
  "Alcantara|Romblon": "5509",
  "Banton": "5515",
  "Cajidiocan": "5512",
  "Calatrava|Romblon": "5503",
  "Concepcion|Romblon": "5516",
  "Corcuera": "5514",
  "Ferrol": "5506",
  "Looc|Romblon": "5507",
  "Magdiwang": "5511",
  "Odiongan": "5505",
  "Romblon": "5500",
  "San Agustin|Romblon": "5501",
  "San Andres|Romblon": "5504",
  "San Fernando|Romblon": "5513",
  "San Jose|Romblon": "5510",
  "Santa Fe|Romblon": "5508",
  "Santa Maria|Romblon": "5502",

  // ================= REGION V =================
  // ================= ALBAY =================
  "Bacacay": "4509",
  "Camalig": "4502",
  "Daraga": "4501",
  "Guinobatan": "4503",
  "Jovellar": "4515",
  "City of Legazpi": "4500",
  "Libon": "4507",
  "City of Ligao": "4504",
  "Malilipot": "4510",
  "Malinao|Albay": "4512",
  "Manito": "4514",
  "Oas": "4505",
  "Pio Duran": "4516",
  "Polangui": "4506",
  "Rapu-Rapu": "4517",
  "Santo Domingo|Albay": "4508",
  "City of Tabaco": "4511",
  "Tiwi": "4513",

  // ================= CAMARINES NORTE =================
  "Basud": "4608",
  "Capalonga": "4607",
  "Daet": "4600",
  "Jose Panganiban": "4606",
  "Labo": "4604",
  "Mercedes|Camarines Norte": "4601",
  "Paracale": "4605",
  "San Lorenzo Ruiz": "4610",
  "San Vicente|Camarines Norte": "4609",
  "Santa Elena": "4611",
  "Talisay|Camarines Norte": "4602",
  "Vinzons": "4603",

  // ================= CAMARINES SUR =================
  "Baao": "4432",
  "Balatan": "4436",
  "Bato|Camarines Sur": "4435",
  "Bombon": "4404",
  "Buhi": "4433",
  "Bula": "4430",
  "Cabusao": "4427",
  "Calabanga": "4405",
  "Camaligan": "4402",
  "Canaman": "4402",
  "Caramoan": "4429",
  "Del Gallego": "4411",
  "Gainza": "4403",
  "Garchitorena": "4428",
  "Goa": "4422",
  "City of Iriga": "4431",
  "Lagonoy": "4425",
  "Libmanan": "4407",
  "Lupi": "4409",
  "Magarao": "4403",
  "Milaor": "4413",
  "Minalabac": "4414",
  "Nabua": "4434",
  "City of Naga|Camarines Sur": "4400",
  "Ocampo": "4406",
  "Pamplona|Camarines Sur": "4416",
  "Pasacao": "4417",
  "Pili": "4418",
  "Presentacion": "4424",
  "Ragay": "4410",
  "Sagñay": "4421",
  "San Fernando|Camarines Sur": "4415",
  "San Jose|Camarines Sur": "4423",
  "Sipocot": "4408",
  "Siruma": "4407",
  "Tigaon": "4420",
  "Tinambac": "4426",

  // ================= CATANDUANES =================
  "Bagamanoc": "4807",
  "Baras|Catanduanes": "4803",
  "Bato|Catanduanes": "4801",
  "Caramoran": "4808",
  "Gigmoto": "4804",
  "Pandan|Catanduanes": "4809",
  "Panganiban": "4806",
  "San Andres|Catanduanes": "4810",
  "San Miguel|Catanduanes": "4802",
  "Viga": "4805",
  "Virac": "4800",

  // ================= MASBATE =================
  "Aroroy": "5406",
  "Baleno": "5413",
  "Balud": "5412",
  "Batuan|Masbate": "5415",
  "Cataingan": "5405",
  "Cawayan": "5409",
  "Claveria|Masbate": "5419",
  "Esperanza|Masbate": "5407",
  "Mandaon": "5411",
  "City of Masbate": "5400",
  "Milagros": "5410",
  "Mobo": "5401",
  "Monreal": "5418",
  "Palanas": "5404",
  "Pio V. Corpuz": "5406",
  "Placer|Masbate": "5408",
  "San Fernando|Masbate": "5416",
  "San Jacinto|Masbate": "5417",
  "San Pascual|Masbate": "5420",
  "Uson": "5402",

  // ================= SORSOGON =================
  "Barcelona": "4712",
  "Bulan": "4706",
  "Bulusan": "4711",
  "Casiguran|Sorsogon": "4702",
  "Castilla": "4713",
  "Donsol": "4715",
  "Gubat": "4710",
  "Irosin": "4707",
  "Juban": "4703",
  "Magallanes|Sorsogon": "4705",
  "Matnog": "4708",
  "Pilar|Sorsogon": "4714",
  "Prieto Diaz": "4711",
  "Santa Magdalena": "4709",
  "City of Sorsogon": "4700",

  // ================= REGION VI =================
  // ================= AKLAN =================
  "Altavas": "5616",
  "Balete|Aklan": "5614",
  "Banga|Aklan": "5601",
  "Batan": "5615",
  "Buruanga": "5609",
  "Ibajay": "5613",
  "Kalibo": "5600",
  "Lezo": "5605",
  "Libacao": "5602",
  "Madalag": "5603",
  "Makato": "5611",
  "Malay": "5608",
  "Malinao|Aklan": "5606",
  "Nabas": "5612",
  "New Washington": "5610",
  "Numancia": "5604",
  "Tangalan": "5612",

  // ================= ANTIQUE =================
  "Anini-y": "5717",
  "Barbaza": "5706",
  "Belison": "5701",
  "Bugasong": "5704",
  "Caluya": "5711",
  "Culasi": "5708",
  "Hamtic": "5715",
  "Laua-an": "5705",
  "Libertad|Antique": "5710",
  "Pandan|Antique": "5712",
  "Patnongon": "5702",
  "San Jose de Buenavista": "5700",
  "San Remigio|Antique": "5714",
  "Sebaste": "5709",
  "Sibalom": "5713",
  "Tibiao": "5707",
  "Tobias Fornier": "5716",
  "Valderrama": "5703",

  // ================= CAPIZ =================
  "Cuartero": "5811",
  "Dao": "5810",
  "Dumalag": "5813",
  "Dumarao": "5812",
  "Ivisan": "5805",
  "Jamindan": "5808",
  "Ma-ayon": "5809",
  "Mambusao": "5807",
  "Panay": "5801",
  "Panitan": "5815",
  "Pilar|Capiz": "5804",
  "Pontevedra|Capiz": "5802",
  "President Roxas": "5803",
  "City of Roxas": "5800",
  "Sapian": "5806",
  "Sigma": "5816",
  "Tapaz": "5814",

  // ================= GUIMARAS =================
  "Buenavista|Guimaras": "5044",
  "Jordan": "5045",
  "Nueva Valencia": "5046",
  "San Lorenzo": "5047",
  "Sibunag": "5048",

  // ================= ILOILO =================
  "Ajuy": "5012",
  "Alimodian": "5040",
  "Anilao": "5009",
  "Badiangan": "5033",
  "Balasan": "5018",
  "Banate": "5010",
  "Barotac Nuevo": "5007",
  "Barotac Viejo": "5011",
  "Batad": "5017",
  "Bingawan": "5041",
  "Cabatuan|Iloilo": "5031",
  "Calinog": "5040",
  "Carles": "5019",
  "Concepcion|Iloilo": "5013",
  "Dingle": "5035",
  "Dueñas": "5038",
  "Dumangas": "5006",
  "Estancia": "5017",
  "Guimbal": "5022",
  "Igbaras": "5029",
  "City of Iloilo": "5000",
  "Janiuay": "5034",
  "Lambunao": "5042",
  "Leganes": "5003",
  "Lemery|Iloilo": "5043",
  "Leon": "5039",
  "Maasin|Iloilo": "5030",
  "Miagao": "5023",
  "Mina": "5032",
  "New Lucena": "5005",
  "Oton": "5020",
  "City of Passi": "5037",
  "Pavia": "5001",
  "Pototan": "5008",
  "San Dionisio": "5015",
  "San Enrique|Iloilo": "5036",
  "San Joaquin": "5024",
  "San Miguel|Iloilo": "5025",
  "San Rafael|Iloilo": "5039",
  "Santa Barbara|Iloilo": "5002",
  "Sara": "5014",
  "Tigbauan": "5021",
  "Tubungan": "5027",
  "Zarraga": "5004",

  // ================= NEGROS OCCIDENTAL =================
  "City of Bacolod": "6100",
  "City of Bago": "6101",
  "Binalbagan": "6107",
  "City of Cadiz": "6121",
  "Calatrava|Negros Occidental": "6126",
  "Candoni": "6110",
  "Cauayan": "6112",
  "Enrique B. Magalona": "6118",
  "City of Escalante": "6124",
  "City of Himamaylan": "6108",
  "Hinigaran": "6106",
  "Hinoba-an": "6114",
  "Ilog": "6109",
  "Isabela|Negros Occidental": "6128",
  "City of Kabankalan": "6111",
  "City of La Carlota": "6130",
  "La Castellana": "6131",
  "Manapla": "6120",
  "Moises Padilla": "6132",
  "Murcia": "6129",
  "Pontevedra|Negros Occidental": "6122",
  "Pulupandan": "6104",
  "City of Sagay": "6122",
  "Salvador Benedicto": "6133",
  "City of San Carlos|Negros Occidental": "6127", 
  "San Enrique|Negros Occidental": "6104",
  "City of Silay": "6116",
  "City of Sipalay": "6113",
  "Talisay City": "6115",
  "Toboso": "6125",
  "Valladolid": "6103",
  "City of Victorias": "6119",

  // ================= REGION VII =================
  // ================= BOHOL =================
  "Alburquerque": "6302",
  "Alicia|Bohol": "6314",
  "Anda|Bohol": "6311",
  "Antequera": "6335",
  "Baclayon": "6301",
  "Balilihan": "6342",
  "Batuan|Bohol": "6318",
  "Bien Unido": "6326",
  "Bilar": "6317",
  "Buenavista|Bohol": "6333",
  "Calape": "6328",
  "Candijay": "6312",
  "Carmen|Bohol": "6319",
  "Catigbian": "6343",
  "Clarin|Bohol": "6330",
  "Corella": "6337",
  "Cortes|Bohol": "6341",
  "Dagohoy": "6322",
  "Danao|Bohol": "6344",
  "Dauis": "6339",
  "Dimiao": "6305",
  "Duero": "6309",
  "Garcia Hernandez": "6307",
  "Getafe": "6334",
  "Guindulman": "6310",
  "Inabanga": "6329",
  "Jagna": "6308",
  "Lila": "6304",
  "Loay": "6303",
  "Loboc": "6316",
  "Loon": "6327",
  "Mabini|Bohol": "6313",
  "Maribojoc": "6336",
  "Panglao": "6340",
  "Pilar|Bohol": "6321",
  "President Carlos P. Garcia": "6346",
  "Sagbayan": "6331",
  "San Isidro|Bohol": "6332",
  "San Miguel|Bohol": "6323",
  "Sevilla": "6347",
  "Sierra Bullones": "6320",
  "Sikatuna": "6338",
  "City of Tagbilaran": "6300",
  "Talibon": "6325",
  "Trinidad": "6324",
  "Tubigon": "6329",
  "Ubay": "6315",
  "Valencia|Bohol": "6306",

  // ================= CEBU =================
  "Alcantara|Cebu": "6033",
  "Alcoy": "6023",
  "Alegria|Cebu": "6030",
  "Aloguinsan": "6040",
  "Argao": "6021",
  "Asturias": "6042",
  "Badian": "6031",
  "Balamban": "6041",
  "Bantayan": "6052",
  "Barili": "6036",
  "City of Bogo": "6010",
  "Boljoon": "6024",
  "Borbon": "6008",
  "City of Carcar": "6019",
  "Carmen|Cebu": "6005",
  "Catmon": "6006",
  "City of Cebu": "6000",
  "Compostela|Cebu": "6003",
  "Consolacion": "6001",
  "Cordova": "6017",
  "City of Danao": "6004",
  "Dumanjug": "6035",
  "Ginatilan": "6031",
  "City of Lapu-Lapu": "6015",
  "Liloan|Cebu": "6002",
  "Madridejos": "6053",
  "Malabuyoc": "6029",
  "City of Mandaue": "6014",
  "Medellin": "6012",
  "Minglanilla": "6046",
  "Moalboal": "6032",
  "City of Naga|Cebu": "6037", 
  "Oslob": "6025",
  "Pilar|Cebu": "6048",
  "Pinamungajan": "6039",
  "Poro": "6049",
  "Ronda": "6034",
  "Samboan": "6027",
  "San Fernando|Cebu": "6018",
  "San Francisco|Cebu": "6050",
  "San Remigio|Cebu": "6011",
  "Santa Fe|Cebu": "6047",
  "Santander": "6026",
  "Sibonga": "6020",
  "Sogod|Cebu": "6007",
  "Tabogon": "6009",
  "Tabuelan": "6044",
  "City of Talisay": "6045",
  "City of Toledo": "6038",
  "Tuburan|Cebu": "6043",
  "Tudela|Cebu": "6051",

  // ================= NEGROS ORIENTAL =================
  "Amlan": "6203",
  "Ayungon": "6210",
  "Bacong": "6216",
  "City of Bais": "6206",
  "Basay": "6222",
  "City of Bayawan": "6221",
  "Bindoy": "6209",
  "City of Canlaon": "6223",
  "Dauin": "6217",
  "City of Dumaguete": "6200",
  "City of Guihulngan": "6214",
  "Jimalalud": "6212",
  "La Libertad|Negros Oriental": "6213",
  "Mabinay": "6207",
  "Manjuyod": "6208",
  "Pamplona|Negros Oriental": "6218",
  "San Jose|Negros Oriental": "6202",
  "Siaton": "6219",
  "Sibulan": "6201",
  "City of Tanjay": "6204",
  "Tayasan": "6211",
  "Valencia|Negros Oriental": "6215",
  "Vallehermoso": "6214",
  "Zamboanguita": "6218",

  // ================= SIQUIJOR =================
  "Enrique Villanueva": "6225",
  "Larena": "6226",
  "Lazi": "6228",
  "Maria": "6229",
  "San Juan|Siquijor": "6227",
  "Siquijor": "6225",

  // ================= REGION VIII =================
  // ================= BILIRAN =================
  "Almeria": "6543",
  "Biliran": "6549",
  "Cabucgayan": "6550",
  "Caibiran": "6548",
  "Culaba": "6547",
  "Kawayan": "6544",
  "Maripipi": "6545",
  "Naval": "6543",

  // ================= EASTERN SAMAR =================
  "Arteche": "6822",
  "Balangiga": "6812",
  "Balangkayan": "6801",
  "City of Borongan": "6800",
  "Can-avid": "6806",
  "Dolores|Eastern Samar": "6817",
  "General MacArthur": "6805",
  "Giporlos": "6811",
  "Guiuan": "6809",
  "Hernani": "6804",
  "Jipapad": "6819",
  "Lawaan": "6813",
  "Llorente": "6803",
  "Maslog": "6820",
  "Maydolong": "6802",
  "Mercedes|Eastern Samar": "6808",
  "Oras": "6818",
  "Quinapondan": "6810",
  "Salcedo": "6807",
  "San Julian": "6814",
  "San Policarpo": "6821",
  "Sulat": "6815",
  "Taft": "6816",

  // ================= LEYTE =================
  "Abuyog": "6510",
  "Alangalang": "6517",
  "Albuera": "6542",
  "Babatngon": "6520",
  "Barugo": "6519",
  "Bato|Leyte": "6525",
  "City of Baybay": "6521",
  "Burauen": "6516",
  "Calubian": "6534",
  "Capoocan": "6530",
  "Carigara": "6529",
  "Dagami": "6515",
  "Dulag": "6505",
  "Hilongos": "6524",
  "Hindang": "6523",
  "Inopacan": "6522",
  "Isabel": "6539",
  "Jaro": "6511",
  "Javier": "6511",
  "Julita": "6506",
  "Kananga": "6531",
  "La Paz|Leyte": "6508",
  "Leyte": "6533",
  "MacArthur": "6509",
  "Mahaplag": "6512",
  "Matag-ob": "6532",
  "Matalom": "6526",
  "Mayorga": "6507",
  "Merida": "6540",
  "City of Ormoc": "6541",
  "Palo": "6501",
  "Palompon": "6538",
  "Pastrana": "6514",
  "San Isidro|Leyte": "6535",
  "San Miguel|Leyte": "6518",
  "Santa Fe|Leyte": "6502",
  "Tabango": "6536",
  "City of Tacloban": "6500",
  "Tabontabon": "6504",
  "Tanauan": "6502",
  "Tolosa": "6503",
  "Tunga": "6528",
  "Villaba": "6537",

  // ================= NORTHERN SAMAR =================
  "Allen": "6405",
  "Biri": "6417",
  "Bobon": "6401",
  "Capul": "6408",
  "Catarman|Northern Samar": "6400",
  "Catubig": "6418",
  "Gamay": "6422",
  "Laoang": "6411",
  "Lapinig": "6423",
  "Las Navas": "6420",
  "Lavezares": "6404",
  "Lope de Vega": "6403",
  "Mapanas": "6421",
  "Mondragon": "6417",
  "Palapag": "6412",
  "Pambujan": "6413",
  "Rosario|Northern Samar": "6416",
  "San Antonio|Northern Samar": "6407",
  "San Isidro|Northern Samar": "6409",
  "San Jose|Northern Samar": "6402",
  "San Roque": "6415",
  "San Vicente|Northern Samar": "6419",
  "Silvino Lobos": "6414",
  "Victoria|Northern Samar": "6406",

  // ================= SAMAR (WESTERN SAMAR) =================
  "Almagro": "6724",
  "Basey": "6702",
  "City of Calbayog": "6710",
  "Calbiga": "6715",
  "City of Catbalogan": "6706",
  "Daram": "6722",
  "Gandara": "6707",
  "Hinabangan": "6713",
  "Jiabong": "6701",
  "Marabut": "6703",
  "Matuguinao": "6708",
  "Motiong": "6704",
  "Pagsanghan": "6705",
  "Pinabacdao": "6716",
  "San Jorge": "6707",
  "San Jose de Buan": "6711",
  "San Sebastian": "6714",
  "Santa Margarita": "6709",
  "Santa Rita|Samar": "6718",
  "Santo Niño|Samar": "6711",
  "Tagapul-an": "6723",
  "Tarangnan": "6704",
  "Villareal": "6717",
  "Zumarraga": "6725",

  // ================= SOUTHERN LEYTE =================
  "Anahawan": "6610",
  "Bontoc|Southern Leyte": "6604",
  "Hinunangan": "6608",
  "Hinundayan": "6609",
  "Libagon": "6615",
  "Liloan|Southern Leyte": "6612",
  "City of Maasin": "6600",
  "Macrohon": "6601",
  "Malitbog|Southern Leyte": "6603",
  "Padre Burgos|Southern Leyte": "6602",
  "Pintuyan": "6614",
  "Saint Bernard": "6611",
  "San Francisco|Southern Leyte": "6613",
  "San Juan|Southern Leyte": "6611",
  "San Ricardo": "6617",
  "Silago": "6607",
  "Sogod|Southern Leyte": "6606",
  "Tomas Oppus": "6605",
  "Limasawa": "6618",

  // ================= REGION IX =================
  // ================= ZAMBOANGA DEL NORTE =================
  "Baliguian": "7123",
  "City of Dapitan": "7101",
  "City of Dipolog": "7100",
  "Gutalac": "7118",
  "Jose Dalman": "7111",
  "Kalawit": "7124",
  "Katipunan": "7109",
  "La Libertad|Zamboanga del Norte": "7119",
  "Labason": "7117",
  "Leon B. Postigo": "7112",
  "Liloy": "7115",
  "Manukan": "7110",
  "Mutia": "7107",
  "Piñan": "7105",
  "Polanco": "7106",
  "President Manuel A. Roxas": "7102",
  "Rizal|Zamboanga del Norte": "7104",
  "Salug": "7114",
  "Sergio Osmeña Sr.": "7108",
  "Siayan": "7113",
  "Sibuco": "7122",
  "Sibutad": "7103",
  "Sindangan": "7112",
  "Siocon": "7120",
  "Sirawai": "7121",
  "Tampilisan": "7116",

  // ================= ZAMBOANGA DEL SUR =================
  "Aurora|Zamboanga del Sur": "7020",
  "Bayog": "7011",
  "Dimataling": "7032",
  "Dinas": "7033",
  "Dumalinao": "7015",
  "Dumingag": "7028",
  "Guipos": "7017",
  "Josefina": "7027",
  "Kumalarang": "7013",
  "Labangan": "7017",
  "Lakewood": "7014",
  "Lapuyan": "7037",
  "Mahayag": "7026",
  "Margosatubig": "7035",
  "Midsalip": "7021",
  "Molave": "7023",
  "City of Pagadian": "7016",
  "Pitogo|Zamboanga del Sur": "7038",
  "Ramon Magsaysay": "7024",
  "San Pablo|Zamboanga del Sur": "7031",
  "San Miguel|Zamboanga del Sur": "7029",
  "Sominot": "7022",
  "Tabina": "7034",
  "Tambulig": "7025",
  "Tigbao": "7019",
  "Tukuran": "7019",
  "Vincenzo A. Sagun": "7036",
  "City of Zamboanga": "7000",

  // ================= ZAMBOANGA SIBUGAY =================
  "Alicia|Zamboanga Sibugay": "7040",
  "Buug": "7009",
  "Diplahan": "7039",
  "Imelda": "7007",
  "Ipil": "7001",
  "Kabasalan": "7005",
  "Mabuhay": "7010",
  "Malangas": "7003",
  "Naga|Zamboanga Sibugay": "7001",
  "Olutanga": "7041",
  "Payao": "7008",
  "Roseller Lim": "7002",
  "Siay": "7006",
  "Talusan": "7012",
  "Titay": "7003",
  "Tungawan": "7018",

  // ================= REGION X =================
  // ================= BUKIDNON =================
  "Baungon": "8707",
  "Cabanglasan": "8723",
  "Damulog": "8721",
  "Dangcagan": "8719",
  "Don Carlos": "8712",
  "Impasug-ong": "8702",
  "Kadingilan": "8713",
  "Kalilangan": "8718",
  "Kibawe": "8720",
  "Kitaotao": "8716",
  "Lantapan": "8722",
  "Libona": "8706",
  "City of Malaybalay": "8700",
  "Malitbog|Bukidnon": "8704",
  "Manolo Fortich": "8703",
  "Maramag": "8714",
  "Pangantucan": "8717",
  "Quezon|Bukidnon": "8715",
  "San Fernando|Bukidnon": "8711",
  "Sumilao": "8701",
  "Talakag": "8708",
  "City of Valencia|Bukidnon": "8709", 

  // ================= CAMIGUIN =================
  "Catarman|Camiguin": "9104",
  "Guinsiliban": "9105",
  "Mahinog": "9101",
  "Mambajao": "9100",
  "Sagay|Camiguin": "9103",

  // ================= LANAO DEL NORTE =================
  "Bacolod|Lanao del Norte": "9205",
  "Baloi": "9217",
  "Baroy": "9210",
  "City of Iligan": "9200",
  "Kapatagan|Lanao del Norte": "9214",
  "Kauswagan": "9202",
  "Lala": "9211",
  "Linamon": "9201",
  "Magsaysay|Lanao del Norte": "9215",
  "Maigo": "9206",
  "Matungao": "9203",
  "Munai": "9219",
  "Nunungan": "9216",
  "Pantao Ragat": "9208",
  "Pantar": "9218",
  "Poona Piagapo": "9204",
  "Salvador": "9212",
  "Sapad": "9213",
  "Sultan Naga Dimaporo": "9215",
  "Tagoloan|Lanao del Norte": "9222",
  "Tangcal": "9220",
  "Tubod|Lanao del Norte": "9209",

  // ================= MISAMIS OCCIDENTAL =================
  "Aloran": "7206",
  "Baliangao": "7211",
  "Bonifacio": "7215",
  "Calamba|Misamis Occidental": "7210",
  "Clarin|Misamis Occidental": "7201",
  "Concepcion|Misamis Occidental": "7213",
  "Jimenez": "7204",
  "Lopez Jaena": "7208",
  "City of Oroquieta": "7207",
  "City of Ozamiz": "7200",
  "Panaon": "7205",
  "Plaridel|Misamis Occidental": "7209",
  "Sapang Dalaga": "7212",
  "Sinacaban": "7203",
  "City of Tangub": "7214",
  "Tudela|Misamis Occidental": "7202",

  // ================= MISAMIS ORIENTAL =================
  "Alubijid": "9018",
  "Balingasag": "9005",
  "Balingoan": "9011",
  "Binuangan": "9008",
  "City of Cagayan de Oro": "9000",
  "Claveria|Misamis Oriental": "9004",
  "City of El Salvador": "9017",
  "City of Gingoog": "9014",
  "Gitagum": "9019",
  "Initao": "9022",
  "Jasaan": "9003",
  "Kinoguitan": "9010",
  "Lagonglong": "9006",
  "Laguindingan": "9012",
  "Libertad|Misamis Oriental": "9021",
  "Lugait": "9025",
  "Magsaysay|Misamis Oriental": "9015",
  "Manticao": "9024",
  "Medina": "9013",
  "Naawan": "9023",
  "Opol": "9016",
  "Salay": "9007",
  "Sugbongcogon": "9009",
  "Tagoloan|Misamis Oriental": "9001",
  "Talisayan": "9012",
  "Villanueva": "9002",

  // ================= REGION XI =================
  // ================= DAVAO DE ORO =================
  "Compostela|Davao de Oro": "8803",
  "Laak": "8810",
  "Mabini|Davao de Oro": "8807",
  "Maco": "8806",
  "Maragusan": "8808",
  "Mawab": "8802",
  "Monkayo": "8805",
  "Montevista": "8801",
  "Nabunturan": "8800",
  "New Bataan": "8804",
  "Pantukan": "8809",

  // ================= DAVAO DEL NORTE =================
  "Asuncion": "8102",
  "Braulio E. Dujali": "8106",
  "Carmen|Davao del Norte": "8101",
  "City of Island Garden City of Samal": "8119",
  "Kapalong": "8113",
  "New Corella": "8107",
  "City of Panabo": "8105",
  "San Isidro|Davao del Norte": "8109", 
  "Santo Tomas|Davao del Norte": "8112",
  "City of Tagum": "8100",
  "Talaingod": "8114",

  // ================= DAVAO DEL SUR =================
  "Bansalan": "8005",
  "City of Davao": "8000",
  "City of Digos": "8002",
  "Hagonoy|Davao del Sur": "8006",
  "Kiblawan": "8008",
  "Magsaysay|Davao del Sur": "8004",
  "Malalag": "8010",
  "Matanao": "8003",
  "Padada": "8007",
  "Santa Cruz|Davao del Sur": "8001",
  "Sulop": "8009",

  // ================= DAVAO OCCIDENTAL =================
  "Don Marcelino": "8013",
  "Jose Abad Santos": "8014",
  "Malita": "8012",
  "Santa Maria|Davao Occidental": "8011",
  "Sarangani": "8015",

  // ================= DAVAO ORIENTAL =================
  "Baganga": "8204",
  "Banaybay": "8208",
  "Boston": "8206",
  "Caraga": "8203",
  "Cateel|Davao Oriental": "8205",
  "Governor Generoso": "8210",
  "Lupon": "8207",
  "Manay": "8202",
  "City of Mati": "8200",
  "San Isidro|Davao Oriental": "8209", 
  "Tarragona": "8201",

  // ================= REGION XII =================
  // ================= COTABATO (NORTH COTABATO) =================
  "Alamada": "9413",
  "Aleosan": "9415",
  "Antipas": "9414",
  "Arakan": "9417",
  "Banisilan": "9416",
  "Carmen|Cotabato": "9408",
  "Kabacan": "9407",
  "City of Kidapawan": "9400",
  "Libungan": "9411",
  "M'lang": "9402",
  "Magpet": "9404",
  "Makilala": "9401",
  "Matalam": "9406",
  "Midsayap": "9410",
  "Pigcawayan": "9412",
  "Pikit": "9409",
  "President Roxas|Cotabato": "9405", 
  "Tulunan": "9403",

  // ================= SARANGANI =================
  "Alabel": "9501",
  "Glan": "9517",
  "Kiamba": "9514",
  "Maasim": "9502",
  "Maitum": "9515",
  "Malapatan": "9516",
  "Malungon": "9503",

  // ================= SOUTH COTABATO =================
  "Banga|South Cotabato": "9511",
  "City of General Santos": "9500",
  "City of Koronadal": "9506",
  "Lake Sebu": "9518",
  "Norala": "9508",
  "Polomolok": "9504",
  "Santo Niño|South Cotabato": "9509", 
  "Surallah": "9512",
  "T'Boli": "9513",
  "Tampakan": "9507",
  "Tantangan": "9510",
  "Tupi": "9505",

  // ================= SULTAN KUDARAT =================
  "Bagumbayan": "9810",
  "Columbio": "9801",
  "Esperanza|Sultan Kudarat": "9802",
  "Isulan": "9805",
  "Kalamansig": "9808",
  "Lambayong": "9803",
  "Lebak": "9807",
  "Lutayan": "9811",
  "Palimbang": "9809",
  "President Quirino": "9804",
  "Senator Ninoy Aquino": "9812",
  "City of Tacurong": "9800",

  // ================= REGION XIII =================
  // ================= AGUSAN DEL NORTE =================
  "Buenavista|Agusan del Norte": "8601",
  "City of Butuan": "8600",
  "City of Cabadbaran": "8605",
  "Carmen|Agusan del Norte": "8603",
  "Jabonga": "8607",
  "Kitcharao": "8609",
  "Las Nieves": "8610",
  "Magallanes|Agusan del Norte": "8604",
  "Nasipit": "8602",
  "Remedios T. Romualdez": "8611",
  "Santiago|Agusan del Norte": "8608",
  "Tubay": "8606",

  // ================= AGUSAN DEL SUR =================
  "City of Bayugan": "8502",
  "Bunawan": "8506",
  "Esperanza|Agusan del Sur": "8502",
  "La Paz|Agusan del Sur": "8508",
  "Loreto|Agusan del Sur": "8507",
  "Prosperidad": "8500",
  "Rosario|Agusan del Sur": "8504",
  "San Francisco|Agusan del Sur": "8501",
  "San Luis|Agusan del Sur": "8511",
  "Santa Josefa": "8512",
  "Sibagat": "8503",
  "Talacogon": "8510",
  "Trento": "8505",
  "Veruela": "8509",

  // ================= DINAGAT ISLANDS =================
  "Basilisa": "8413",
  "Cagdianao": "8411",
  "Dinagat": "8412",
  "Libjo": "8414",
  "Loreto|Dinagat Islands": "8415",
  "San Jose|Dinagat Islands": "8427", 
  "Tubajon": "8426",

  // ================= SURIGAO DEL NORTE =================
  "Alegria|Surigao del Norte": "8425",
  "Bacuag": "8408",
  "Burgos|Surigao del Norte": "8424",
  "Claver": "8410",
  "Dapa": "8419",
  "Del Carmen": "8420",
  "General Luna": "8409",
  "Gigaquit": "8409",
  "Mainit": "8407",
  "Malimono": "8402",
  "Pilar|Surigao del Norte": "8421",
  "Placer|Surigao del Norte": "8405",
  "San Benito": "8423",
  "San Francisco|Surigao del Norte": "8401",
  "San Isidro|Surigao del Norte": "8422",
  "Sison|Surigao del Norte": "8404",
  "Socorro|Surigao del Norte": "8416",
  "City of Surigao": "8400",
  "Tagana-an": "8403",
  "Tubod|Surigao del Norte": "8406",

  // ================= SURIGAO DEL SUR =================
  "Barobo": "8309",
  "Bayabas": "8303",
  "City of Bislig": "8311",
  "Cagwait": "8304",
  "Cantilan": "8317",
  "Carmen|Surigao del Sur": "8315",
  "Carrascal": "8318",
  "Cortes|Surigao del Sur": "8301",
  "Hinatuan": "8310",
  "Lanuza": "8316",
  "Lianga": "8307",
  "Lingig": "8312",
  "Madrid": "8316",
  "Marihatag": "8306",
  "San Agustin|Surigao del Sur": "8305",
  "San Miguel|Surigao del Sur": "8301",
  "Tagbina": "8308",
  "Tago": "8302",
  "City of Tandag": "8300",

  // ================= BARMM =================
  // ================= BASILAN =================
  "Akbar": "7300",
  "Al-Barka": "7300",
  "Hadji Mohammad Ajul": "7300",
  "Hadji Muhtamad": "7301",
  "City of Isabela": "7300",
  "City of Lamitan": "7302",
  "Lantawan": "7301",
  "Maluso": "7303",
  "Sumisip": "7305",
  "Tabuan-Lasa": "7304",
  "Tipo-Tipo": "7304",
  "Tuburan|Basilan": "7306",
  "Ungkaya Pukan": "7300",

  // ================= LANAO DEL SUR =================
  "Amai Manabilang": "9706",
  "Bacolod-Kalawi": "9316",
  "Balabagan": "9302",
  "Balindong": "9318",
  "Bayang": "9309",
  "Binidayan": "9310",
  "Buadiposo-Buntong": "9703",
  "Bubong": "9708",
  "Butig": "9305",
  "Calanogas": "9319",
  "Ditsaan-Ramain": "9713",
  "Ganassi": "9311",
  "Kapai": "9709",
  "Kapatagan|Lanao del Sur": "9301",
  "Lumba-Bayabao": "9707",
  "Lumbaca-Unayan": "9307",
  "Lumbayanague": "9306",
  "Madalum": "9315",
  "Madamba": "9314",
  "Maguing": "9715",
  "Malabang": "9300",
  "City of Marawi": "9700",
  "Marantao": "9711",
  "Marogong": "9303",
  "Masiu": "9308",
  "Mulondo": "9702",
  "Pagayawan": "9312",
  "Piagapo": "9710",
  "Picong": "9301",
  "Poona Bayabao": "9705",
  "Pualas": "9313",
  "Saguiaran": "9701",
  "Sultan Dumalondong": "9315",
  "Tagoloan II": "9716",
  "Tamparan": "9704",
  "Taraka": "9712",
  "Tubaran|Lanao del Sur": "9304",
  "Tugaya": "9317",
  "Wao": "9706",

  // ================= MAGUINDANAO DEL NORTE =================
  "Barira": "9405",
  "Buldon": "9404",
  "City of Cotabato": "9600",
  "Datu Blah T. Sinsuat": "9601",
  "Datu Odin Sinsuat": "9601",
  "Kabuntalan": "9606",
  "Matanog": "9408",
  "Northern Kabuntalan": "9606",
  "Parang|Maguindanao del Norte": "9604",
  "Sultan Kudarat": "9605",
  "Sultan Mastura": "9600",
  "Sultan Sumagka": "9608",
  "Upi": "9602",

  // ================= MAGUINDANAO DEL SUR =================
  "Ampatuan": "9609",
  "Buluan": "9616",
  "Datu Abdulla Sangki": "9609",
  "Datu Anggal Midtimbang": "9600",
  "Datu Hoffer Ampatuan": "9600",
  "Datu Montawal": "9412",
  "Datu Paglas": "9617",
  "Datu Piang": "9607",
  "Datu Salibo": "9607",
  "Datu Saudi-Ampatuan": "9607",
  "Datu Unsay": "9607",
  "Guindulungan": "9600",
  "Mamasapano": "9608",
  "Mangudadatu": "9616",
  "Pagagawan": "9412",
  "Pagalungan": "9412",
  "Paglat": "9616",
  "Pandag": "9616",
  "Rajah Buayan": "9607",
  "Shariff Aguak": "9608",
  "Shariff Saydona Mustapha": "9600",
  "South Upi": "9603",
  "Sultan sa Barongis": "9611",

  // ================= SULU =================
  "Banguingui": "7400",
  "Hadji Panglima Tahil": "7401",
  "Indanan": "7407",
  "Jolo": "7400",
  "Kalingalan Caluang": "7412",
  "Lugus": "7403",
  "Luuk": "7408",
  "Maimbung": "7405",
  "Old Panamao": "7402",
  "Pandami": "7404",
  "Panglima Estino": "7409",
  "Pangutaran": "7414",
  "Parang|Sulu": "7406",
  "Pata": "7413",
  "Patikul": "7401",
  "Siasi": "7410",
  "Talipao": "7411",
  "Tapul": "7415",

  // ================= TAWl-TAWl =================
  "Bongao": "7500",
  "Languyan": "7509",
  "Mapun": "7508",
  "Panglima Sugala": "7501",
  "Sapa-Sapa": "7503",
  "Sibutu": "7500",
  "Simunul": "7505",
  "Sitangkai": "7506",
  "South Ubian": "7504",
  "Tandubas": "7502",
  "Turtle Islands": "7507",
};

export const DUPLICATE_CITIES = [
  "Alegria", "Alicia", "Alcantara", "Alcala", "Anda", "Aurora", "Bacolod", "Balete", "Banga", "Baras", "Bato", "Batuan", "Buenavista", "Burgos", "Cabatuan", "Calamba", "Calatrava", "Candelaria", "Carmen", "Casiguran", "Catarman", "Cateel", "Clarin", "Claveria", "Compostela", "Concepcion", "Cortes", "Dolores", "Esperanza", "Hagonoy", "Infanta", "Isabela", "Kalayaan", "Kapatagan", "La Libertad", "La Paz", "Lemery", "Libertad", "Liloan", "Looc", "Loreto", "Luna", "Mabini", "Magallanes", "Magsaysay", "Malinao", "Malitbog", "Mercedes", "Morong", "Naga", "Naguilian", "Padre Burgos", "Pamplona", "Pandan", "Parang", "Pilar", "Pitogo", "Placer", "Plaridel", "Pontevedra", "Quezon", "Quirino", "Rizal", "Rosario", "Roxas", "Sagay", "Samal", "Sampaloc", "San Agustin", "San Andres", "San Antonio", "San Enrique", "San Fernando", "San Francisco", "San Guillermo", "San Ildefonso", "San Isidro", "San Jacinto", "San Joaquin", "San Jorge", "San Jose", "San Juan", "San Lorenzo", "San Luis", "San Manuel", "San Mariano", "San Mateo", "San Miguel", "San Narciso", "San Pablo", "San Pascual", "San Policarpo", "San Quintin", "San Rafael", "San Remigio", "San Roque", "San Vicente", "Santa Ana", "Santa Barbara", "Santa Cruz", "Santa Elena", "Santa Fe", "Santa Lucia", "Santa Maria", "Santa Rita", "Santa Teresita", "Santiago", "Santo Domingo", "Santo Niño", "Santo Tomas", "Sison", "Socorro", "Sogod", "Tagoloan", "Talisay", "Tanauan", "Taytay", "Tubay", "Tubod", "Tuburan", "Tudela", "Valencia", "Victoria"
];